var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigmodule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00059 10.5336C6.60134 10.5336 5.46699 9.39929 5.46699 8C5.46699 6.60074 6.60134 5.46643 8.00059 5.46643C9.39985 5.46643 10.5342 6.60074 10.5342 8C10.5342 9.39929 9.39985 10.5336 8.00059 10.5336ZM13.053 6.90629C12.9201 6.28773 12.6767 5.71023 12.3441 5.19566L13.0125 4.52726L11.4696 2.9855L10.8018 3.65335C10.2872 3.3208 9.70976 3.07742 9.0912 2.94455V2H6.90999V2.94455C6.29143 3.07742 5.71396 3.3208 5.1994 3.65335L4.53155 2.9855L2.98867 4.52726L3.65705 5.19566C3.3245 5.71023 3.08112 6.28773 2.94821 6.90629H2.00119L2 9.08746H2.94817C3.08108 9.70602 3.32447 10.2835 3.65701 10.7981L2.98609 11.469L4.52785 13.012L5.19933 12.3404C5.71393 12.673 6.29143 12.9164 6.90999 13.0493V14H9.0912V13.0493C9.70976 12.9164 10.2873 12.673 10.8019 12.3404L11.4733 13.012L13.0151 11.469L12.3442 10.7981C12.6767 10.2835 12.9201 9.70602 13.053 9.08746H14.0012V6.90629H13.053Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigmodule);
export default __webpack_public_path__ + "static/media/configmodule.daa6786aca1a0e37f228ba30fb361712.svg";
export { ForwardRef as ReactComponent };